import { useLang } from '../context/LangContext';

const STATUS_KEYS = {
  conform: 'fs_conform', niet_conform: 'fs_niet_conform',
  observatie: 'fs_observatie', kans_verbetering: 'fs_kans_verbetering',
  nvt: 'fs_nvt', niet_beoordeeld: 'fs_niet_beoordeeld',
  draft: 'status_draft', in_progress: 'status_in_progress',
  review: 'status_review', closed: 'status_closed', archived: 'status_archived',
  laag: 'prio_laag', gemiddeld: 'prio_gemiddeld', hoog: 'prio_hoog', kritiek: 'prio_kritiek',
};

export default function StatusBadge({ status }) {
  const { t } = useLang();
  return (
    <span className={`badge badge-${status}`}>{t(STATUS_KEYS[status] || status)}</span>
  );
}
